import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "giftDetail"
  }, [_c('n-gift-head', {
    ref: "nGiftHeadRef"
  }), _c('div', {
    staticClass: "giftDetail-body page-body"
  }, [_c('div', {
    staticClass: "giftDetail-main page-main"
  }, [_vm.tabList.length >= 2 ? _c('div', {
    staticClass: "giftDetail-tab"
  }, _vm._l(_vm.tabList, function (item, index) {
    return _c('div', {
      staticClass: "giftDetail-tab-item",
      class: _vm.luckyInfo.id == item.id && 'active',
      on: {
        "click": function ($event) {
          return _vm.onTab(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.price_extras.stars.price_stars)))]);
  }), 0) : _vm._e(), _vm.isPageLoading ? _c('div', {
    staticClass: "giftDetail-loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _vm._e(), _c('div', {
    staticClass: "giftDetail-con",
    class: _vm.isPageLoading && 'loading'
  }, [_c('div', {
    staticClass: "giftDetail-step2",
    class: _vm.step == 0 && 'show'
  }, [_c('div', {
    staticClass: "giftDetail__title"
  }, [_vm._v("GIFT")]), _c('div', {
    staticClass: "giftDetail-draw"
  }, [_c('div', {
    ref: "itemsContainer",
    staticClass: "giftDetail-draw-items",
    class: !_vm.isDrawOpening && 'hidden'
  }, [!_vm.fullPrizeList ? _vm._l(4, function (_) {
    return _c('div', {
      staticClass: "giftDetail-draw-item"
    });
  }) : _vm._l(_vm.fullPrizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "giftDetail-draw-item"
    }, [_c('div', {
      staticClass: "giftDetail-draw-item-main"
    }, [_c('div', {
      staticClass: "giftDetail-draw-item__img"
    }, [_c('img', {
      attrs: {
        "src": item.gift_extra.gift_thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "giftDetail-draw-item__label"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "giftDetail-draw-item__price"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.gift_extra.gift_stars)))])])]);
  })], 2), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll"
    }],
    ref: "itemsScrollContainer",
    staticClass: "giftDetail-draw-items scroll",
    class: _vm.isDrawOpening && 'hidden',
    on: {
      "scroll": _vm.onDrawScroll
    }
  }, _vm._l(_vm.prizeListScroll, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "giftDetail-draw-item",
      class: item.id == null && 'empty'
    }, [item.id !== null ? [_c('div', {
      staticClass: "giftDetail-draw-item-main"
    }, [_c('div', {
      staticClass: "giftDetail-draw-item__img"
    }, [_c('img', {
      attrs: {
        "src": item.gift_extra.gift_thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "giftDetail-draw-item__label"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "giftDetail-draw-item__price"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.gift_extra.gift_stars)))])])] : _vm._e()], 2);
  }), 0), _c('div', {
    ref: "selectorRef",
    staticClass: "giftDetail-draw-selector",
    style: {
      background: `url(${require(`@images/tapcoin/new/gift-selector.png`)}) center/100% auto no-repeat`
    }
  }, [_c('span', {
    staticClass: "selector-top",
    style: {
      background: `url(${require(`@images/tapcoin/new/gift-selector-arrow.png`)}) center/auto 100% no-repeat`
    }
  }), _c('span', {
    staticClass: "selector-bottom",
    style: {
      background: `url(${require(`@images/tapcoin/new/gift-selector-arrow.png`)}) center/auto 100% no-repeat`
    }
  })])]), _vm.isDrawOpening ? _c('div', {
    staticClass: "giftDetail-draw-loading"
  }, [_vm._v(" Opening "), _c('div', {
    staticClass: "circleLoading"
  })]) : _vm._e(), !_vm.isDrawOpening ? [_c('div', {
    staticClass: "giftDetail-switch"
  }, [_c('div', {
    staticClass: "giftDetail-switch__title"
  }, [_vm._v("Demo mode")]), _c('div', {
    staticClass: "giftDetail-switch-main",
    class: _vm.isDemo && 'active',
    on: {
      "click": _vm.onDemoSwitch
    }
  }, [_c('div', {
    staticClass: "giftDetail-switch-bar"
  })])]), _vm.luckyInfo ? _c('div', {
    staticClass: "giftDetail-btns"
  }, [_c('div', {
    staticClass: "btn-open",
    on: {
      "click": _vm.onOpen
    }
  }, [!_vm.isDemo ? [_vm.luckyInfo?.price_extras?.stars?.price_stars ? _c('div', {
    staticClass: "btn-open__label"
  }, [_c('span', [_vm._v(" Open Case")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/ton-stars.png`),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.price_extras.stars.price_stars)))]) : _vm._e()] : [_c('div', {
    staticClass: "btn-open__label"
  }, [_vm._v("Open Free")])]], 2)]) : _vm._e()] : _vm._e()], 2), _vm.step == 1 && _vm.drawResult && _vm.drawResult?.winning_item ? _c('div', {
    staticClass: "giftDetail-step3"
  }, [_c('div', {
    staticClass: "giftDetail__title"
  }, [_vm._v("GIFT")]), _c('div', {
    staticClass: "giftDetail-step3-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.drawResult.winning_item.gift_extra[0].gift_thumb,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "giftDetail-step3__sub"
  }, [_vm.drawResult.winning_item.title ? _c('em', [_vm._v(_vm._s(_vm.drawResult.winning_item.title))]) : _vm._e(), !_vm.isDemo ? _c('p', [_vm._v("ltems can be withdrawn in "), _c('span', {
    on: {
      "click": function ($event) {
        return _vm.$router.push('/giftInventory');
      }
    }
  }, [_vm._v("inventory")])]) : _vm._e()]), _vm.isDemo ? _c('div', {
    staticClass: "giftDetail-switch"
  }, [_c('div', {
    staticClass: "giftDetail-switch__title"
  }, [_vm._v("Demo mode")]), _c('div', {
    staticClass: "giftDetail-switch-main",
    class: _vm.isDemo && 'active'
  }, [_c('div', {
    staticClass: "giftDetail-switch-bar"
  })])]) : _vm._e(), _c('div', {
    staticClass: "giftDetail-step3-btns"
  }, [!_vm.isDemo ? [_vm.rowGiftItem.order_id <= 0 ? [_c('div', {
    staticClass: "btn btn-getTelegram",
    on: {
      "click": function ($event) {
        return _vm.onGetToTelegram(_vm.drawResult.winning_item);
      }
    }
  }, [_vm._v("Get to Telegram")]), _c('div', {
    staticClass: "btn btn-sell-star",
    on: {
      "click": function ($event) {
        return _vm.onSellPlatform(_vm.drawResult.winning_item);
      }
    }
  }, [_vm._v("Sell it for "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/ton-stars.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.drawResult.winning_item.gift_extra[0].recycling_stars)))])] : _vm.rowGiftItem.order_id > 0 && _vm.rowGiftItem.order_status === 0 ? [_c('div', {
    staticClass: "btn btn-getTelegram",
    on: {
      "click": function ($event) {
        return _vm.onGetToTelegram(_vm.drawResult.winning_item);
      }
    }
  }, [_vm._v("Get to Telegram")])] : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "btn btn-try",
    on: {
      "click": _vm.onTry
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh"
    }
  }), _vm._v(" Try Again")], 1)], 2)]) : _vm._e(), _c('div', {
    staticClass: "giftDetail-case"
  }, [_c('div', {
    staticClass: "giftDetail-case__title"
  }, [_vm._v("CASE CONTENT")]), _c('div', {
    staticClass: "giftDetail-list"
  }, _vm._l(_vm.prizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "giftDetail-item"
    }, [_c('div', {
      staticClass: "giftDetail-item-avatar"
    }, [_c('div', {
      staticClass: "giftDetail-item-avatar-main"
    }, [_c('img', {
      attrs: {
        "src": item.gift_extra.gift_thumb,
        "alt": ""
      }
    })]), item.odds || item.title ? _c('div', {
      staticClass: "giftDetail-item-avatar__label"
    }, [item.odds ? _c('span', [_vm._v("Odds: " + _vm._s(item.odds) + " ")]) : _vm._e(), _vm._v(" "), item.title ? _c('em', [_vm._v(_vm._s(item.title))]) : _vm._e()]) : _vm._e()]), _c('div', {
      staticClass: "giftDetail-item__price"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.gift_extra.gift_stars)) + "  /  "), _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/BIGTON.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.gift_extra.gift_tons)))])]);
  }), 0)])])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1), _c('pop-sell-gift', {
    ref: "popSellGiftRef",
    on: {
      "finish": _vm.popSellGiftFinish
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };